import React from "react";
import "./Loading.scss";

export default function Loading({width = 100, height = 100, withBackground = true}) {
  return (
    <div className={`loading-gif ${withBackground ? "withBackground" : ""}`}>
      <img className="loading-image" src="/loading.gif" alt="Loading..." width={width} height={height} />
    </div>
  );
}
